export const generateSearchParam = (searchParamObj?: any): string => {
  let searchParam: string = '';
  const data: any = { ...searchParamObj };
  Object.keys(data).forEach(searchInput => {
    if (data[searchInput]) {
      searchParam += `&${searchInput}=${data[searchInput]}`;
    }
  });
  return searchParam;
};
